import { Box, Text } from '@instamenu/ui-system-next';
import { palette } from '@instamenu/ui-vanilla-extract';
import { formatAddress } from '@instamenu/formatters';
import { PackagingOptions } from './packaging-options';
import { Order } from '@instamenu/context-checkout';

export const PickupDetails = ({ order }: { order: Order }) => (
  <>
    <Box css={{ paddingBottom: 20, gap: 8 }}>
      <Text variant="caption1" css={{ color: palette.gray600, paddingBottom: 8 }}>
        Pickup location
      </Text>
      <Text>
        {order.restaurant.name} at {formatAddress(order.restaurant.address)}
      </Text>
    </Box>
    <PackagingOptions order={order} />
  </>
);
